import { render } from "./AddressRadio.vue?vue&type=template&id=54744c0c&scoped=true"
import script from "./AddressRadio.vue?vue&type=script&lang=js"
export * from "./AddressRadio.vue?vue&type=script&lang=js"

import "./AddressRadio.vue?vue&type=style&index=0&id=54744c0c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54744c0c"]])

export default __exports__